import { errorNamespace } from "@domain-first/errors";

export const DomainFirstTypesError = errorNamespace("@DOMAIN-FIRST/TYPES")
